const { markdownText } = require('./markdown');

function normalizeSearchText(text = '') {
  return text.toLowerCase().replace(/\s+/g, ' ').trim();
}

function parseSearchQuery(query = '') {
  const terms = [];
  // Treat an unfinished quote as a phrase too, so searching stays useful while typing.
  const pattern = /"([^"]*)(?:"|$)|“([^”]*)(?:”|$)|([^\s"“”]+)/g;
  for (const match of query.matchAll(pattern)) {
    const phrase = match[1] !== undefined || match[2] !== undefined;
    const text = normalizeSearchText(match[1] ?? match[2] ?? match[3]);
    if (text) terms.push({ text, phrase });
  }
  return terms;
}

function searchableText(item, fullText = false) {
  // Mutation type labels participate in title search, independently of full-text search.
  const mutationType = item.category === 'Mutations'
    ? (item.content || '').match(/^\*\*Mutation Type:\*\*[ \t]*([^\r\n]+)/m)?.[1]
    : undefined;
  const fields = [item.name, item.category, mutationType];
  if (fullText) fields.push(markdownText(item.content || ''));
  // A phrase cannot accidentally span the name, category, and body.
  return fields.filter(Boolean).map(normalizeSearchText).join('\u0000');
}

const wordCharacter = /[\p{L}\p{N}_]/u;
function matchesSearch(text, terms) {
  return terms.every(term => {
    if (!term.phrase) return text.includes(term.text);
    let position = text.indexOf(term.text);
    while (position !== -1) {
      const end = position + term.text.length;
      const startsAtWord = !wordCharacter.test(term.text[0]) || !wordCharacter.test(text[position - 1] || '');
      const endsAtWord = !wordCharacter.test(term.text.at(-1)) || !wordCharacter.test(text[end] || '');
      if (startsAtWord && endsAtWord) return true;
      position = text.indexOf(term.text, position + 1);
    }
    return false;
  });
}

module.exports = { normalizeSearchText, parseSearchQuery, searchableText, matchesSearch };
